import { ThemeProvider } from "styled-components";
import GlobalStyle from "./components/GlobalStyle";
import HeroSection from "./components/HeroSection";
import theme from "./utils/theme";
import { personConfig } from "./utils/seo-config";

import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(personConfig),
        }}
      />
      <div className="App">
        <GlobalStyle />
        <HeroSection />
      </div>
    </ThemeProvider>
  );
}

export default App;
